import { render, staticRenderFns } from "./staffcustomerNew.vue?vue&type=template&id=20db1fd1"
import script from "./staffcustomerNew.vue?vue&type=script&lang=js"
export * from "./staffcustomerNew.vue?vue&type=script&lang=js"
import style0 from "./staffcustomerNew.vue?vue&type=style&index=0&id=20db1fd1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports